import { render } from "./PdfStampPlacer.vue?vue&type=template&id=3bf47dc1&scoped=true"
import script from "./PdfStampPlacer.vue?vue&type=script&lang=js"
export * from "./PdfStampPlacer.vue?vue&type=script&lang=js"

import "./PdfStampPlacer.vue?vue&type=style&index=0&id=3bf47dc1&scoped=true&lang=css"

import exportComponent from "/Users/paulestrada/Desktop/PDESTRADA/Contablus/contablusDashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bf47dc1"]])

export default __exports__